
import RoomCard from "@/components/provider/RoomCard";

interface Room {
  id: string;
  name: string;
  description?: string;
  capacity: number;
  image_url?: string;
  provider_id: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

interface Service {
  id: string;
  name: string;
  room_id?: string;
}

interface RoomsTabProps {
  rooms: Room[] | undefined;
  services: Service[] | undefined;
  roomsLoading: boolean;
}

const RoomsTab = ({ rooms, services, roomsLoading }: RoomsTabProps) => {
  if (roomsLoading) {
    return (
      <div className="space-y-4">
        <div>
          <h3 className="text-lg font-semibold mb-4">Available Rooms</h3>
          <p className="text-gray-600 mb-6 text-sm sm:text-base">Browse our available rooms and facilities.</p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[1, 2].map((i) => (
            <div key={i} className="animate-pulse">
              <div className="h-32 bg-gray-300 rounded-lg mb-4"></div>
              <div className="h-4 bg-gray-300 rounded mb-2"></div>
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-semibold mb-4">Available Rooms</h3>
        <p className="text-gray-600 mb-6 text-sm sm:text-base">Browse our available rooms and facilities.</p>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {rooms && rooms.length > 0 ? (
          rooms.map((room) => {
            const roomServices = services?.filter(service => service.room_id === room.id) || [];
            return (
              <RoomCard
                key={room.id}
                room={{
                  ...room,
                  description: room.description || ''
                }}
                servicesCount={roomServices.length}
              />
            );
          })
        ) : (
          <div className="col-span-full text-center text-gray-500 py-8">
            <p>No rooms found for this provider.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RoomsTab;
